import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const validPage = (value) => {
  const page = Number(value);
  return Number.isInteger(page) && page > 0 ? page : null;
};

const pageFromLegacyUrl = (url) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return validPage(new URL(url, "https://calendar-list.invalid").searchParams.get("page"));
  } catch (_error) {
    return null;
  }
};

const pagedAction = (route, values) => {
  const page = validPage(values && values.page) || pageFromLegacyUrl(values && values.next_page_url);
  return `${route}${page ? `?page=${page}` : ""}`;
};

const view = (values) => {
  const result = values && values.result ? values.result : "";
  const pagetype = values && values.pagetype ? values.pagetype : "";
  // const pagination = values && values.option ? false : true;
  const action = pagedAction("afterlogin/staff/view", values);
  const data = {
    action: action,
    pagination: false, //true or false
    id: values && values.id && values.id != "all_staff" ? values.id : "",
    result: result, //business_name,owner_name
    pagetype: pagetype,
    page_name: values && values.page_name ? values.page_name : "",
    singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : "",
    option: values && values.option ? values.option : "",
    formName: values && values.formName ? values.formName : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const resourceitemview = (values) => {
  const result = values && values.result ? values.result : "";
  const pagetype = values && values.pagetype ? values.pagetype : "";
  const resource_id = values && values.resource_id ? values.resource_id : "";
  // const pagination = values && values.option ? false : true;
  const action = pagedAction("afterlogin/resourceitem/view", values);
  const data = {
    action: action,
    pagination: false, //true or false
    id: values && values.id ? values.id : "",
    resource_id: resource_id,
    resource_item_id: values && values.resource_item_id ? values.resource_item_id : "",
    result: result, //business_name,owner_name
    pagetype: pagetype,
    page_name: values && values.page_name ? values.page_name : "",
    singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : "",
    formName: values && values.formName ? values.formName : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const calendarApiController = {
  view,
  resourceitemview
};
export default calendarApiController;
